import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './plugins';
import { Capacitor } from '@capacitor/core';

import '~assets/style/app.styl';

// Froala WYSIWYG is admin-only. Skip its CSS on native (the mobile app
// has no admin UI surface) — saves ~100 KB of unused styles in the APK.
if (!Capacitor.isNativePlatform()) {
    // Async import lets webpack split the CSS into its own chunk so it
    // does not sit in the critical path of every cold start.
    import(
        /* webpackChunkName: "froala-css" */
        'froala-editor/css/froala_editor.pkgd.min.css'
    );
}

Vue.config.productionTip = false;

// OneSignal web push is only for the browser/PWA. Inside the Capacitor
// WebView (iOS/Android apps) native push uses @capacitor/push-notifications
// via src/services/PushNotificationsNative.js — no service workers.
if (!Capacitor.isNativePlatform()) {
    window.OneSignal = window.OneSignal || [];
    window.OneSignal.push(() => {
        window.OneSignal.init({
            appId: process.env.VUE_APP_ONESIGNAL,
            allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production'
        });
    });
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
